export default {
    MODE: String(process.env.REACT_APP_MODE) as 'DEV' | 'TEST' | 'PROD',
    URL: eval(process.env.REACT_APP_URL ?? ''),

    SUPPORT_TELEGRAM_URL: String(process.env.REACT_APP_SUPPORT_TELEGRAM_URL),
};
